window.productFinderMaps = {};

window.productFinderDefaultMap = {
  question: "What metal colour are you after?",
  facet: "named_tags.Metal Colour",
  label: "Select Metal",
  answers: [
      {
          name: "Yellow Gold",
          svg: "yellow-gold",
          value: "Yellow Gold"
      },
      {
          name: "Rose Gold",
          svg: "rose-gold",
          value: "Rose Gold"
      },
      {
          name: "White Gold",
          svg: "white-gold",
          value: "White Gold",
      },
      {
          name: "Silver and Yellow Gold",
          svg: "silver-yellow-gold",
          value: "Silver Yellow Gold"
      },
      {
          name: "Silver and Rose Gold",
          svg: "silver-rose-gold",
          value: "Silver Rose Gold"
      },
      {
          name: "Sterling Silver",
          svg: "silver",
          value: "Sterling Silver"
      },
      {
          name: "White and Rose Gold",
          svg: "white-rose-gold",
          value: "White and Rose Gold"
      },
      {
          name: "White and Yellow Gold",
          svg: "white-yellow-gold",
          value: "White and Yellow Gold"
      },
  ],
  default: {
      question: "What cut are you looking for?",
      facet: "named_tags.Center Stone Shape",
      label: "Select Cut",
      answers: [
          {
              name: "Trilliant",
              svg: "trilliant",
              value: "trilliant"
          },
          {
              name: "Princess",
              svg: "princess",
              value: "princess"
          },
          {
              name: "Heart",
              svg: "heart",
              value: "heart"
          },
          {
              name: "Asscher",
              svg: 'asscher',
              value: "asscher"
          },
          {
              name: "Rectangle",
              svg: "radiant",
              value: "rectangle"
          },
          {
              name: "Round",
              svg: "round",
              value: "round"
          },
          {
              name: "Pear",
              svg: "pear",
              value: "pear"
          },
          {
              name: "Oval",
              svg: "oval",
              value: "oval"
          },
          {
              name: "Emerald",
              svg: 'emerald',
              value: "emerald"
          },
          {
              name: "Cushion",
              svg: 'cushion',
              value: "cushion"
          },
          {
              name: "Marquise",
              svg: "marquise",
              value: "marquise"
          },
      ],
      // default: {
      //     question: "When do you need this product",
      //     facet: "named_tags.Time",
      //     label: "Select Date",
      //     answers: [
      //         {
      //             name: "Today",
      //             value: "1 day"
      //         },
      //         {
      //             name: "Tomorrow",
      //             value: "2 day"
      //         }
      //     ]
      // }
  }
}
